/* MxL Complete the Look.
   - Direct add of a recommended product with hidden line-item properties
     (_mxl_reco, _mxl_reco_src) so orders carry attribution for every reason.
   - Analytics: CustomEvents on document plus window.dataLayer pushes. Events:
     mxl_reco_impression, mxl_reco_click, mxl_reco_add, mxl_reco_remove,
     mxl_reco_fallback_loaded. No existing analytics are altered.
   - Behavioral fallback (Priority 5): only when the Liquid engine rendered
     nothing, fetch Shopify's recommendations endpoint once per product.
   - Cart updates reuse the theme's own section-render flow so the drawer
     stays consistent. Listeners are delegated once; drawer re-renders are
     handled without re-binding. */
window.MxlCartQueue = window.MxlCartQueue || (function () {
  var tail = Promise.resolve();
  var lastStart = 0;
  var MIN_GAP = 600; /* ms between cart mutations: rapid bursts of /cart/*
                        requests trip the storefront's bot-protection
                        challenge, which then fails EVERY later cart call in
                        the session with a non-JSON interstitial */
  function paced(fn) {
    return function () {
      var wait = Math.max(0, MIN_GAP - (Date.now() - lastStart));
      return new Promise(function (res) { setTimeout(res, wait); }).then(function () {
        lastStart = Date.now();
        return fn();
      });
    };
  }
  return {
    run: function (fn) {
      var r = tail.then(paced(fn), paced(fn));
      tail = r.catch(function () {});
      return r;
    }
  };
})();

(function () {
  if (window.__mxlCtlInit) return;
  window.__mxlCtlInit = true;

  var seenImpressions = {};

  function track(name, detail) {
    detail = detail || {};
    detail.ts = new Date().toISOString();
    try {
      document.dispatchEvent(new CustomEvent("mxl:" + name, { detail: detail }));
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: "mxl_" + name }, detail));
    } catch (e) {}
  }

  function payloadFor(card, extra) {
    var mod = card.closest("[data-mxl-ctl]");
    return Object.assign({
      reason: card.dataset.reason,
      tier: card.dataset.tier || "primary_match",
      reco_product_id: card.dataset.recoId,
      reco_product_handle: card.dataset.recoHandle,
      source_product_id: mod ? mod.dataset.sourceId : null,
      placement: mod ? mod.dataset.placement : null,
      module: mod ? mod.dataset.module || "primary" : null,
      heading: mod ? mod.dataset.heading || null : null,
      cart_token: mod ? mod.dataset.cartToken : null,
      promo_id: (function () {
        var p = mod && mod.querySelector("[data-mxl-ctl-promo]");
        return p ? p.dataset.promoId || null : null;
      })()
    }, extra || {});
  }

  /* ---------- impressions (once per product+placement per page life) ---------- */
  var io = "IntersectionObserver" in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var card = en.target;
          var key = (card.dataset.recoId || "") + ":" + ((card.closest("[data-mxl-ctl]") || {}).dataset || {}).placement;
          if (seenImpressions[key]) return;
          seenImpressions[key] = true;
          track("reco_impression", payloadFor(card));
          io.unobserve(card);
        });
      }, { threshold: 0.5 })
    : null;

  function scan(root) {
    (root || document).querySelectorAll("[data-mxl-ctl-card]").forEach(function (card) {
      if (io && !card.__mxlObserved) {
        card.__mxlObserved = true;
        io.observe(card);
      }
    });
    /* blurb fade plays once per product per session, not on every re-render */
    (root || document).querySelectorAll("[data-mxl-blurb]").forEach(function (b) {
      var k = "mxl_blurb_" + b.dataset.pid;
      try {
        if (sessionStorage.getItem(k)) b.classList.add("no-anim");
        else sessionStorage.setItem(k, "1");
      } catch (e) {}
    });
    /* remove detection: diff reco-tagged cart lines between renders */
    diffRecoLines();
    /* behavioral fallback trigger */
    (root || document).querySelectorAll("[data-mxl-ctl-empty]").forEach(maybeFallback);
    dedupeCarousel();
  }

  /* ---------- v17 unified product cards (delegated) ----------
     Cards render with a server-computed default variant already selected.
     On any option change (tap or keyboard) we run the theme's own
     ProductCard.updateCardVariant first (price/image/form id stay canonical),
     then resolve the exact combination against the card's embedded variant
     JSON: available -> theme Add flow; existing-but-sold-out -> Notify Me via
     the shared mxl-bis drawer; nonexistent combination -> disabled
     "Select options" state. Choose Options anchors keep a ?variant= deep link
     to the current combination. Everything is document-delegated - cards from
     filtering/sorting/infinite scroll need no re-binding. */
  function mxlResolveCard(card) {
    var dataEl = card.querySelector("[data-product-card-variants]");
    if (!dataEl) return;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    var selected = {};
    card.querySelectorAll(".js-card-option-group input:checked").forEach(function (inp) {
      var g = inp.closest(".js-card-option-group");
      var pos = g && g.dataset.optionPosition;
      if (pos) selected["option" + pos] = inp.value;
    });
    var matched =
      variants.find(function (v) {
        return Object.keys(selected).every(function (k) {
          return v[k] === selected[k];
        });
      }) || null;
    var anchor = card.querySelector(".product-card__quickadd > a.product-card__button");
    if (anchor && matched) {
      try {
        var u = new URL(anchor.getAttribute("href"), window.location.origin);
        u.searchParams.set("variant", matched.id);
        anchor.setAttribute("href", u.pathname + u.search);
      } catch (err) {}
    }
    var wrap = card.querySelector("product-form.product-card__quickadd");
    if (!wrap) return;
    wrap.classList.remove("mxl-state-notify", "mxl-state-invalid");
    if (!matched) {
      wrap.classList.add("mxl-state-invalid");
      return;
    }
    if (!matched.available) {
      wrap.classList.add("mxl-state-notify");
      var nb = wrap.querySelector("[data-mxl-card-notify]");
      if (nb) {
        nb.setAttribute("data-mxl-bis-variant-id", String(matched.id));
        nb.setAttribute("data-mxl-bis-variant-title", matched.title || "");
      }
    }
  }
  document.addEventListener("change", function (e) {
    var input = e.target;
    if (!input.matches || !input.matches(".js-card-option-group input[type='radio']")) return;
    var card = input.closest("product-card");
    if (!card) return;
    /* change fires for keyboard selection too, which the theme's click-only
       listener misses; updateCardVariant is idempotent after a click run */
    if (typeof card.updateCardVariant === "function") {
      var group = input.closest(".js-card-option-group");
      if (group && typeof card.updateCardInputAttr === "function") {
        card.updateCardInputAttr(group.querySelectorAll("input"), input);
      }
      card.updateCardVariant(input.dataset ? input.dataset.variantId : "");
    }
    mxlResolveCard(card);
  });
  document.addEventListener("click", function (e) {
    var nbtn = e.target.closest("[data-mxl-card-notify]");
    if (!nbtn) return;
    e.preventDefault();
    var drawer =
      document.querySelector("mxl-bis-drawer[data-mxl-bis-primary]") ||
      document.querySelector("mxl-bis-drawer");
    if (drawer && typeof drawer.show === "function") drawer.show(nbtn);
  });

  /* ---------- clicks ---------- */
  document.addEventListener("click", function (e) {
    var link = e.target.closest("[data-mxl-ctl-link]");
    if (link) {
      var card = link.closest("[data-mxl-ctl-card]");
      if (card) track("reco_click", payloadFor(card));
      return;
    }
    var btn = e.target.closest("[data-mxl-ctl-add]");
    if (btn) addReco(btn);
  });

  /* ---------- reco variant selection: Add <-> Notify Me ----------
     Sold-out sizes are selectable (v19). Selecting one flips the card to
     .mxl-state-notify (Add hidden, Notify Me shown) and pins the exact
     variant on the notify trigger, which opens the existing mxl-bis
     back-in-stock drawer (same data-mxl-card-notify contract and delegated
     click handler as the browsing product cards — no new listeners, forms,
     or Klaviyo objects). Covers drawer radios AND the cart page dropdown. */
  function mxlSyncRecoAction(card, available, variantId, variantTitle) {
    card.classList.toggle("mxl-state-notify", !available);
    var nbtn = card.querySelector("[data-mxl-card-notify]");
    if (nbtn) {
      nbtn.setAttribute("data-mxl-bis-variant-id", String(variantId));
      nbtn.setAttribute("data-mxl-bis-variant-title", variantTitle || "");
    }
    var btn = card.querySelector("[data-mxl-ctl-add]");
    if (btn && available) {
      btn.disabled = false;
      var label = btn.querySelector("[data-mxl-ctl-add-label]");
      if (label && btn.dataset.addLabel) label.textContent = btn.dataset.addLabel;
    }
  }
  document.addEventListener("change", function (e) {
    var inp = e.target;
    if (!inp.matches) return;
    var isRadio = inp.matches("input[type='radio'][data-mxl-ctl-variant]");
    var isSelect = inp.matches("select[data-mxl-ctl-variant]");
    if (!isRadio && !isSelect) return;
    var card = inp.closest("[data-mxl-ctl-card]");
    if (!card) return;
    if (isRadio) {
      mxlSyncRecoAction(card, inp.dataset.available !== "false", inp.value, inp.dataset.variantTitle);
    } else {
      var opt = inp.options[inp.selectedIndex];
      var avail = !opt || opt.dataset.available !== "false";
      mxlSyncRecoAction(card, avail, inp.value, opt ? opt.dataset.variantTitle || "" : "");
    }
  });

  /* ---------- add to cart ---------- */
  function addReco(btn) {
    var card = btn.closest("[data-mxl-ctl-card]");
    var variantInput = card.querySelector('input[type="radio"][data-mxl-ctl-variant]:checked') || card.querySelector("[data-mxl-ctl-variant]");
    var variantId = variantInput && variantInput.value;
    if (variantInput && variantInput.type === "radio" && !variantInput.checked) variantId = null;
    if (!variantId || btn.disabled) return;
    /* sold-out selections never reach /cart/add — they belong to Notify Me */
    if (variantInput.type === "radio" && variantInput.dataset.available === "false") return;
    var opt = variantInput.tagName === "SELECT" ? variantInput.options[variantInput.selectedIndex] : null;
    if (opt && (opt.disabled || opt.dataset.available === "false")) return;
    btn.disabled = true;
    var label = btn.querySelector("[data-mxl-ctl-add-label]");
    var original = label ? label.textContent : "";
    if (label) label.textContent = "Adding…";
    var err = card.querySelector(".mxl-ctl-card__error");
    if (err) err.remove();

    var pay = payloadFor(card);
    track("reco_add_attempt", Object.assign({ variant_id: variantId }, pay));
    var body = new FormData();
    body.append("id", variantId);
    body.append("quantity", "1");
    body.append("properties[_mxl_reco]", pay.reason || "unknown");
    body.append("properties[_mxl_reco_src]", pay.source_product_id || "");
    body.append("properties[_mxl_reco_pl]", pay.placement || "");
    body.append("properties[_mxl_reco_tier]", pay.tier || "");
    if (pay.promo_id) body.append("properties[_mxl_reco_promo]", pay.promo_id);
    body.append("sections", "cart-drawer,cart-icon-bubble");
    body.append("sections_url", window.location.pathname);

    var doAdd = function () {
      return fetch((window.routes && window.routes.cart_add_url) || "/cart/add", {
        method: "POST",
        headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" },
        body: body
      }).then(function (r) {
        return r.text().then(function (txt) {
          try {
            return JSON.parse(txt);
          } catch (parseErr) {
            /* non-JSON (interstitial/challenge page) — signal for one retry */
            console.debug("[mxl-ctl] add returned non-JSON", { variantId: variantId, status: r.status, snippet: txt.slice(0, 120) });
            var e = new Error("non_json");
            e.mxlRetryable = true;
            throw e;
          }
        });
      });
    };
    window.MxlCartQueue.run(doAdd)
      .catch(function (e) {
        if (e && e.mxlRetryable) {
          return new Promise(function (res) { setTimeout(res, 700); }).then(function () {
            return window.MxlCartQueue.run(doAdd);
          });
        }
        throw e;
      })
      .then(function (state) {
        if (state.status && state.status !== 200) {
          console.debug("[mxl-ctl] add rejected", { variantId: variantId, status: state.status, description: state.description, message: state.message });
          var rejection = new Error(state.description || "add failed");
          rejection.mxlDescription = state.description || "";
          throw rejection;
        }
        /* confirmed good response: clear any stale reco error left on screen */
        document.querySelectorAll(".mxl-ctl-card__error").forEach(function (n) { n.remove(); });
        rememberRecoLine(variantId, pay);
        var onCartPage = window.location.pathname.indexOf("/cart") === 0;
        var drawer = document.querySelector("cart-drawer");
        if (!onCartPage && drawer && typeof drawer.renderContents === "function" && state.sections) {
          /* After an add the drawer must show the UPDATED CART, not the spot
             the shopper was browsing: the re-render adds a line at the top
             and re-ranks the module, so restoring the old scroll offset
             strands the view inside the recommendation module and the cart
             items sit invisibly above it (owner-reported on mobile). Snap
             both possible scrollers to the top — same place the theme's own
             product-page add flow lands. */
          drawer.renderContents(state);
          var snapTop = function () {
            [".cart-drawer__scroll", ".cart-drawer__inner"].forEach(function (sel) {
              var el = drawer.querySelector(sel);
              if (el) el.scrollTop = 0;
            });
          };
          snapTop();
          if (window.requestAnimationFrame) requestAnimationFrame(snapTop);
        }
        if (state.sections && state.sections["cart-icon-bubble"]) {
          var bubble = document.getElementById("cart-icon-bubble");
          if (bubble) bubble.innerHTML = state.sections["cart-icon-bubble"];
        }
        if (onCartPage) refreshCartPage();
        /* success is recorded only after Shopify confirmed the add. The old
           enrichment GET /cart.js here DOUBLED the per-add request count on
           the rate-limited /cart/* path — derive the count from the section
           payload we already received instead. */
        var bubbleCount = null;
        try {
          var tmpB = document.createElement("div");
          tmpB.innerHTML = (state.sections && state.sections["cart-icon-bubble"]) || "";
          var bTxt = tmpB.textContent.replace(/\D+/g, "");
          if (bTxt) bubbleCount = parseInt(bTxt, 10);
        } catch (e2) {}
        track("reco_add", Object.assign({ variant_id: variantId, cart_item_count: bubbleCount }, pay));
        if (label) label.textContent = "Added";
        setTimeout(function () {
          if (label) label.textContent = original;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function (e) {
        track("reco_add_failed", Object.assign({ variant_id: variantId, error: String(e && e.message || "failed") }, pay));
        console.debug("[mxl-ctl] add failed", { variantId: variantId, error: String(e && e.message), description: e && e.mxlDescription });
        if (label) label.textContent = original;
        btn.disabled = false;
        var desc = (e && e.mxlDescription || "").toLowerCase();
        var msg = "We couldn\u2019t update your cart. Please try once more.";
        if (desc.indexOf("sold out") !== -1 || desc.indexOf("unavailable") !== -1) {
          msg = "This size is no longer available.";
        } else if (desc.indexOf("all") !== -1 && desc.indexOf("cart") !== -1) {
          msg = "All available stock for this item is already in your cart.";
        }
        var el = document.createElement("p");
        el.className = "mxl-ctl-card__error";
        el.setAttribute("role", "alert");
        el.textContent = msg;
        card.querySelector(".mxl-ctl-card__controls").after(el);
        setTimeout(function () { el.remove(); }, 5000);
      });
  }

  /* ---------- remove detection (no polling, no extra requests) ---------- */
  function storedLines() {
    try { return JSON.parse(sessionStorage.getItem("mxl_ctl_lines") || "{}"); } catch (e) { return {}; }
  }
  function rememberRecoLine(variantId, pay) {
    var lines = storedLines();
    lines[variantId] = { reason: pay.reason, source_product_id: pay.source_product_id, placement: pay.placement };
    try { sessionStorage.setItem("mxl_ctl_lines", JSON.stringify(lines)); } catch (e) {}
  }
  function diffRecoLines() {
    var lines = storedLines();
    var ids = Object.keys(lines);
    if (!ids.length) return;
    var drawer = document.querySelector("cart-drawer");
    if (!drawer || !drawer.querySelector("cart-drawer-items")) return;
    var present = {};
    drawer.querySelectorAll("[data-variant-id], [data-quantity-variant-id]").forEach(function (el) {
      present[el.dataset.variantId || el.dataset.quantityVariantId] = true;
    });
    if (!Object.keys(present).length) {
      drawer.querySelectorAll('a[href*="variant="]').forEach(function (a) {
        var m = a.href.match(/variant=(\d+)/);
        if (m) present[m[1]] = true;
      });
      if (!Object.keys(present).length) return;
    }
    ids.forEach(function (vid) {
      if (!present[vid]) {
        track("reco_remove", Object.assign({ variant_id: vid, cart_token: null }, lines[vid]));
        delete lines[vid];
      }
    });
    try { sessionStorage.setItem("mxl_ctl_lines", JSON.stringify(lines)); } catch (e) {}
  }

  /* ---------- cart page live refresh ---------- */
  function sectionIdOf(el) {
    var w = el && el.closest(".shopify-section");
    return w ? w.id.replace(/^shopify-section-/, "") : null;
  }
  var refreshing = false;
  function refreshCartPage() {
    if (refreshing) return;
    refreshing = true;
    var mainEl = document.getElementById("main-cart-items");
    var modEl = document.querySelector(".mxl-ctl-section--cart") || document.querySelector("[data-mxl-ctl-empty]");
    var ids = [];
    var mainId = mainEl ? mainEl.dataset.id || sectionIdOf(mainEl) : null;
    var modId = modEl ? sectionIdOf(modEl) : null;
    if (mainId) ids.push(mainId);
    if (modId && modId !== mainId) ids.push(modId);
    if (!ids.length) { refreshing = false; return; }
    fetch(((window.routes && window.routes.cart_url) || "/cart") + "?sections=" + ids.join(","))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        ids.forEach(function (id) {
          var wrap = document.getElementById("shopify-section-" + id);
          if (wrap && sections[id]) {
            var tmp = document.createElement("div");
            tmp.innerHTML = sections[id];
            var inner = tmp.querySelector(".shopify-section") || tmp;
            wrap.innerHTML = inner.innerHTML || sections[id];
          }
        });
        refreshing = false;
        scan(document);
        watchCartMutations();
      })
      .catch(function () { refreshing = false; });
  }
  /* keep the module in sync when the theme's own controls change the cart
     (quantity, remove, last item removed -> module disappears server-side) */
  var cartObserved = null;
  var cartDebounce = null;
  function watchCartMutations() {
    var mainEl = document.getElementById("main-cart-items");
    if (!mainEl || cartObserved === mainEl || !("MutationObserver" in window)) return;
    cartObserved = mainEl;
    new MutationObserver(function () {
      clearTimeout(cartDebounce);
      cartDebounce = setTimeout(function () {
        var modEl = document.querySelector(".mxl-ctl-section--cart");
        if (!modEl) return;
        var modId = sectionIdOf(modEl);
        if (!modId) return;
        fetch(((window.routes && window.routes.cart_url) || "/cart") + "?sections=" + modId)
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            var wrap = document.getElementById("shopify-section-" + modId);
            if (wrap && typeof sections[modId] === "string") {
              var tmp = document.createElement("div");
              tmp.innerHTML = sections[modId];
              wrap.innerHTML = tmp.innerHTML;
              scan(document);
            }
          })
          .catch(function () {});
      }, 350);
    }).observe(mainEl, { childList: true, subtree: true });
  }
  watchCartMutations();

  /* ---------- behavioral fallback (Priority 5) ---------- */
  var fallbackFetched = {};
  function maybeFallback(marker) {
    var pid = marker.dataset.sourceId;
    if (!pid || fallbackFetched[pid]) return;
    fallbackFetched[pid] = true;
    var base = (window.routes && window.routes.product_recommendations_url) || "/recommendations/products";
    fetch(base + "?section_id=mxl-complete-the-look&product_id=" + pid + "&limit=4&intent=related")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var mod = tmp.querySelector("[data-mxl-ctl]");
        if (mod) {
          /* v22: the engine stamps its empty marker with the effective
             department (cart-dominant, else the source product's own) and
             every card carries data-mxl-dept. The fallback section render
             already filters by cart department server-side, but it cannot
             see the requesting product on an empty-cart product page — so
             drop opposite-department cards here too, and skip the module
             entirely if nothing survives (no recommendations beats wrong
             ones). */
          var wantDept = marker.dataset.mxlDept || "";
          if (wantDept === "mens" || wantDept === "womens") {
            var opposite = wantDept === "mens" ? "womens" : "mens";
            var cards = mod.querySelectorAll('[data-mxl-ctl-card][data-mxl-dept="' + opposite + '"]');
            for (var i = 0; i < cards.length; i++) cards[i].remove();
          }
          if (!mod.querySelector("[data-mxl-ctl-card]")) return;
          marker.replaceWith(mod);
          track("reco_fallback_loaded", { source_product_id: pid });
          scan(mod.parentElement || document);
        }
      })
      .catch(function () {});
  }

  /* ---------- observe drawer re-renders ---------- */
  var target = document.querySelector("cart-drawer");
  if (target && "MutationObserver" in window) {
    new MutationObserver(function () { scan(target); }).observe(target, { childList: true, subtree: true });
  }
  /* cart page: keep the exploratory carousel distinct from the primary
     module: hide carousel cards that duplicate cart items or the primary
     recommendation (progressive enhancement, cart template only) */
  function dedupeCarousel() {
    if (window.location.pathname.indexOf("/cart") !== 0) return;
    var mod = document.querySelector('.mxl-ctl--cart[data-mxl-ctl]');
    var blocked = {};
    if (mod && mod.dataset.primaryHandle) blocked[mod.dataset.primaryHandle] = true;
    if (mod) mod.querySelectorAll("[data-mxl-ctl-card]").forEach(function (c) { blocked[c.dataset.recoHandle] = true; });
    document.querySelectorAll(".cart-item__link, .cart-item__name").forEach(function (a) {
      var m = (a.getAttribute("href") || "").match(/\/products\/([a-z0-9-]+)/);
      if (m) blocked[m[1]] = true;
    });
    var handles = Object.keys(blocked);
    if (!handles.length) return;
    var css = handles.map(function (h) {
      return '[id*="popular"] li:has(> * a[href*="/products/' + h + '"]),' +
             '[id*="popular"] .swiper-slide:has(a[href*="/products/' + h + '"]),' +
             '[class*="popular-products"] .swiper-slide:has(a[href*="/products/' + h + '"]),' +
             '[class*="popular-products"] li:has(a[href*="/products/' + h + '"])' +
             '{ display: none !important; }';
    }).join("\n");
    var tag = document.getElementById("mxl-ctl-dedupe");
    if (!tag) {
      tag = document.createElement("style");
      tag.id = "mxl-ctl-dedupe";
      document.head.appendChild(tag);
    }
    if (tag.textContent !== css) tag.textContent = css;
  }
  document.addEventListener("DOMContentLoaded", function () { scan(document); dedupeCarousel(); });
  scan(document);
  dedupeCarousel();
})();
